export default __webpack_public_path__ + "static/media/round-close.b21d836a.svg";